import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Widget} from '../widgets.types';
import {CreativeWidgetsTableState} from './creativeWidgetsTable.types';
import {SharePermission} from 'common/src/modules/sharing/sharing.types';

const widgetsInitialState: CreativeWidgetsTableState = {
  widgets: [],
  sharePermissions: [],
};

const creativeWidgetsTableSlice = createSlice({
  name: 'creativeWidgetsTable',
  initialState: widgetsInitialState,
  reducers: {
    resetWidgetsState: () => widgetsInitialState,
    setWidgetsTableData: (
      state,
      action: PayloadAction<{widgets: Widget[]; sharePermissions: SharePermission[]}>,
    ) => {
      state.widgets = action.payload.widgets;
      state.sharePermissions = action.payload.sharePermissions;
    },
  },
});

const {resetWidgetsState, setWidgetsTableData} = creativeWidgetsTableSlice.actions;

export {resetWidgetsState, setWidgetsTableData};

export default creativeWidgetsTableSlice.reducer;
